import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import arrowRight from "../assets/images/icons/arrow-right.svg";
import searchHeader from "../assets/images/icons/search-header.svg";
import notification from "../assets/images/icons/notification.svg";
import { FaChevronDown } from "react-icons/fa";

export default function Navbar() {
  const [tUserName, setUserName] = useState("");
  const [tCompanyName, setTCompanyName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setUserName(localStorage.getItem("name") || "");
    setTCompanyName(localStorage.getItem("company_name") || "");
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        "https://tradbee-backend.zeroinfo.in/api/logout",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        // Clear local storage
        localStorage.removeItem("token");
        localStorage.removeItem("name");
        localStorage.removeItem("company_name");

        // Redirect to login page
        navigate("/");
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout", error);
    }
  };

  // Mapping routes to page titles
  const pathMappings = {
    "/dashboard/onboarding/business-kyc": "Business KYC",
    "/dashboard/onboarding/management-kyc": "Management KYC",
    "/dashboard/onboarding/business-financials": "Business Finance",
  };

  const currentPath = location.pathname;
  const pageTitle = pathMappings[currentPath] || "Business KYC";

  return (
    <>
      <nav className="navbar navbar-expand-sm dashboard-navbar">
        <div className="container-fluid">
          <div className="col-md-12 d-flex">
            <div className="col-md-4 navbar-logo">
              <p>
                Business Onboarding
                <span className="breadcrumb-arrow">
                  <img src={arrowRight} />
                </span>
                {pageTitle}
              </p>
            </div>
            <div className="col-md-7 d-flex right-search-navbar">
              <div className="col d-flex justify-content-between align-items-center">
                <form className="d-flex">
                  <div className="search-header">
                    <span className="search-icon">
                      <img src={searchHeader} />
                    </span>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search or type a command (Ctrl + G)"
                    />
                  </div>
                </form>

                {/* Profile Dropdown */}
                <div className="profile-info position-relative">
                  <span
                    className="username-initial"
                    onClick={toggleDropdown}
                    style={{ cursor: "pointer" }}
                  >
                    {tUserName.charAt(0)}
                  </span>
                  <span
                    className="username"
                    onClick={toggleDropdown}
                    style={{ cursor: "pointer", marginLeft: "5px" }}
                  >
                    {tUserName} <FaChevronDown style={{ marginLeft: "5px" }} />
                  </span>

                  {isDropdownOpen && (
                    <ul
                      className="dropdown-menu show"
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "100%",
                        background: "#fff",
                        border: "1px solid #ccc",
                        listStyle: "none",
                        padding: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleLogout}
                          style={{
                            background: "none",
                            border: "none",
                            padding: "5px 10px",
                            cursor: "pointer",
                          }}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
